import React from "react";
import "./Realestateauctions.css";
import centerimage from "../../assets/رخصة-المزدات-auction.png"; 
import logoimage from "../../assets/cropped-cropped-cropped-عقاري-1-1 (1).webp";

const Realestatauctions = () => {
  return (
    <>
    
    <div className="heading-h1">
    <h1 className="title">Real Estate Auctions Service</h1>
    </div>
    
      <div className="logo-container">
      <img src={logoimage} alt="Akari Logo" className="logo" />
      </div>
      <div className="content">
      <h2 className="section-title">:Service definition</h2>
        <p className="text">Real Estate Auctions Service</p>
        <h2 className="section-title">:Service Provider:</h2>
        <p className="text">Abdullah Nasser Al-Ateeq Real Estate Office</p>
      <div className="image-container">
        <img src={centerimage} alt="Center Image" className="center-image" />
      </div>

      </div>

      
    
      
     
      
      </>
  );
};

export default Realestatauctions;